export default () => ({
    saveChangesButton: {
        fontWeight: 700,
        marginLeft: 22
    }
});
